module.exports = __webpack_public_path__ + "static/img/Bachelor_010353.3e6ae7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010353.jpg
// module id = 154
// module chunks = 0